var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SModalCommon',{ref:"SModalCommon",attrs:{"title":_vm.config.title}},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.config.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }